import{HttpInterceptor, HttpRequest, HttpHandler}from'@angular/common/http'
import {Injectable}from'@angular/core'
import {AdminAuthService}from'./admin-auth.service'
@Injectable()
export class AdminAuthInterceptor implements HttpInterceptor{
    constructor(private adminAuthService:AdminAuthService){}
    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const token=this.adminAuthService.getToken();
        const authRequest=req.clone({
            headers:req.headers.set('AdminAuthorization',"Bearer "+token)
        })
        return next.handle(authRequest)
    }
}